import { API_URL } from "@/config/api";
import { useAuth } from "@/hooks/useAuth";
import { ArrowLeft, ArrowRight } from "lucide-react";
import moment from "moment";
import { useEffect, useState } from "react";
import { Card, CardContent } from '@/components/ui/card';

const HOURS = [
  "07:00",
  "07:30",
  "08:00",
  "08:30",

  "09:00",
  "09:30",

  "10:00",
  "10:30",

  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",

];

function getStartOfWeek(date) {
  const d = new Date(date);
  const day = d.getDay() === 0 ? 7 : d.getDay();
  d.setDate(d.getDate() - day + 1);
  d.setHours(0, 0, 0, 0);
  return d;
}

function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

export default function AppointmentIndividual() {
  const [currentWeek, setCurrentWeek] = useState(
    getStartOfWeek(new Date())
  );

  const { user } = useAuth();



  // Exemplo de reuniões
  // const meetings = {
  //   "2025-12-22": ["09:00", "14:00"],
  //   "2025-12-23": ["10:00"],
  //   "2025-12-25": ["08:00", "15:00"],
  // };

  const [meetings, setMeetings] = useState({})

  const [selectedMeeting, setSelectedMeeting] = useState(null)

  const daysOfWeek = Array.from({ length: 7 }).map((_, index) =>
    addDays(currentWeek, index)
  );

  function formatDateKey(date) {
    return date.toISOString().split("T")[0];
  }

  function changeWeek(offset) {
    setCurrentWeek(addDays(currentWeek, offset * 7));
  }

  const loadData = async () => {
    let schedules_profissional = await (await fetch(API_URL + '/appointments/schedules/all/all/' + user._id + '?details=all', {
      headers: {
        "Authorization": localStorage.getItem('token'),
        "Accept": "application/json"
      }
    })).json()

    let mapped_meet: any = {}

    schedules_profissional.map((item: any) => {
      if (!mapped_meet[moment(item.date).format('YYYY-MM-DD')]) {
        mapped_meet[moment(item.date).format('YYYY-MM-DD')] = { hours: [], meets: [] }
      }
      // let diff = moment(item.date_end).diff(moment(item.date),'minutes');
      let initial_meet = moment(item.date)
      // while (initial_meet.format('YYYY-MM-DD HH:mm') < moment(item.date_end).format('YYYY-MM-DD HH:mm')) {
        mapped_meet[moment(item.date).format('YYYY-MM-DD')].hours.push(initial_meet.format('HH:mm'))
        mapped_meet[moment(item.date).format('YYYY-MM-DD')].meets.push(item)
        // initial_meet = initial_meet.add(30, 'minutes')
      // }
    })

    setMeetings(mapped_meet);
    console.log(mapped_meet);
  }

  useEffect(() => {
    if (user) {

      loadData();
    }
  }, [user])

  return (
    <div className={"flex flex-col flex-1 shrink  self-stretch  basis-0 min-w-60 max-md:px-5 bg-background-dark " + 'px-6 py-7'}>
      {/* Header */}

      {<div className=" justify-between items-center mb-6">

        <h1 className="text-2xl font-bold">Minha agenda</h1>
        {/* {subtitle && <p style={{color:'grey'}} className="mt-1">{subtitle}</p>} */}
      </div>}
      <Card style={{ maxHeight: window.innerHeight - 150, overflow: 'scroll' }} className="custom-scrollbar w-full border border-[#D8E0F0] rounded-[14px] bg-[#FCFCFC] hover:border-[#c8d0e0] transition-colors">
        <CardContent className="p-[20px] ">

          <div className="flex items-center justify-between mb-6">
            <button
              onClick={() => changeWeek(-1)}
              className="px-4 py-2 bg-blue-300 rounded hover:bg-gray-300"
            >
              <ArrowLeft />
            </button>

            <h2 className="text-xl font-semibold">
              Semana de {currentWeek.toLocaleDateString("pt-BR")}
            </h2>

            <button
              onClick={() => changeWeek(1)}
              className="px-4 py-2 bg-blue-300 rounded hover:bg-gray-300"
            >
              <ArrowRight />

            </button>
          </div>

          {/* Agenda */}
          <div style={{ width: '100%' }}>

            <div className="grid grid-cols-8 bg-white rounded shadow overflow-hidden">
              {/* Coluna de horários */}
              <div className="border-r">
                <div className=" border-b" style={{ height: 40 }} />
                {HOURS.map((hour) => (
                  <div
                    key={hour}
                    style={{ height: 30 }}
                    className=" border-b flex items-center justify-center text-sm text-gray-500"
                  >
                    {hour}
                  </div>
                ))}
              </div>

              {/* Colunas dos dias */}

              {daysOfWeek.map((day) => {
                const dateKey = formatDateKey(day);
                const dayMeetings = meetings[dateKey] || [];

                return (
                  <div key={dateKey} className="border-r last:border-r-0" style={{ position: 'relative' }}>
                    {/* Cabeçalho do dia */}
                    <div style={{ height: 40 }} className=" border-b flex flex-col items-center justify-center bg-gray-100">
                      <span className="text-sm font-medium">
                        {day.toLocaleDateString("pt-BR", { weekday: "short" })}
                      </span>
                      <span className="text-xs text-gray-500">
                        {day.toLocaleDateString("pt-BR")}
                      </span>
                    </div>

                    {/* Horários */}
                    {HOURS.map((hour, index) => {
                      let hasMeeting = dayMeetings?.hours?.includes(hour);
                      hasMeeting = false;
                      // if(dayMeetings?.hours?.)

                      return (
                        <div
                          key={hour}
                          onClick={(e) => {
                            if (hasMeeting) {
                              setSelectedMeeting(dayMeetings?.meets[dayMeetings?.hours?.indexOf(hour)])
                            }
                          }}
                          style={{ cursor: hasMeeting ? 'pointer' : '', height: 30}}
                          className={` border-b flex items-center justify-center text-xs
                      ${hasMeeting
                              ? "bg-blue-500 text-white font-semibold"
                              : "hover:bg-gray-100"
                            }`}
                        >
                          {hasMeeting ? dayMeetings?.meets[dayMeetings?.hours?.indexOf(hour)]?.appointment?.name : ""}
                        </div>
                      );
                    })}

                    {dayMeetings?.hours?.map((hour, index) => {

                        let diff = moment(dateKey + ' '+hour+':00').diff(moment(dateKey + ' 07:00:00'),'minutes');
                        console.log('DIFF',diff)
                        let size = moment(dayMeetings?.meets[dayMeetings?.hours?.indexOf(hour)].date_end).diff(moment(dayMeetings?.meets[dayMeetings?.hours?.indexOf(hour)].date),'minutes');

                        // if(dayMeetings?.hours?.)

                        return (
                          <div
                            key={hour}
                            onClick={(e) => {
                                setSelectedMeeting(dayMeetings?.meets[dayMeetings?.hours?.indexOf(hour)])
                            }}
                            style={{ cursor:  'pointer' , height: size,top:diff+40,right:0,left:0,position:'absolute'  }}
                            className={` border-b flex items-center justify-center text-xs
                      bg-blue-500 text-white font-semibold
                                `}
                          >
                            {dayMeetings?.meets[dayMeetings?.hours?.indexOf(hour)]?.appointment?.name}
                          </div>
                        );
                    })}
                  </div>
                );
              })}
            </div>

          </div>
        </CardContent>
      </Card>
      {selectedMeeting != null && <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center p-4" style={{ zIndex: 1000 }}>
        <div className="bg-white  rounded-2xl shadow-xl p-6" style={{ minWidth: '70%' }}>


          <div className="mt-6">
            <h3 className="text-lg font-semibold mb-2">Reunião {selectedMeeting?.appointment?.name}</h3>


            <ul className="space-y-2">
              {selectedMeeting != null &&
                <li className="p-3 bg-gray-100 rounded-lg">
                  <p><b>Agenda: </b>{selectedMeeting?.appointment?.name}</p>
                  <p><b>Produto/Fase/Atividade: </b>{selectedMeeting?.appointment?.product?.name} {'->'} {selectedMeeting?.appointment?.product?.phases?.filter((item) => item._id == selectedMeeting?.appointment?.phase)[0]?.name} {'->'} {selectedMeeting?.appointment?.product?.phases?.filter((item) => item._id == selectedMeeting?.appointment?.phase)[0]?.activities?.filter((item) => item._id == selectedMeeting?.appointment?.activity)[0]?.name}</p>

                  <p><b>Agendado por: </b>{selectedMeeting?.user?.name}</p>
                  <p><b>Partners envolvidos: </b>{selectedMeeting?.collaborators?.map((item) => item.name).join(', ')}</p>
                  <p><b>Cliente: </b>{selectedMeeting?.client?.name}</p>
                  <p><b>Horário: </b>{moment(selectedMeeting.date).format('HH:mm')} - {moment(selectedMeeting.date_end).format('HH:mm')}</p>
                </li>
              }
            </ul>
          </div>

          <div className="mt-6 text-right">
            <button onClick={() => {
              setSelectedMeeting(null);
            }} className="px-4 py-2 bg-red-500 text-white rounded-lg">Fechar</button>
          </div>
        </div>
      </div>}

    </div>



  );
}
